import {css} from 'lit';
export const styles = css`/* stylelint-disable value-no-vendor-prefix */

:host {
  --padding-unit: 16px;
  --border-radius-unit: 16px;
  --background: var(--contrast-light);

  display: block;
  border-radius: var(--border-radius-unit);
  font-size: var(--bu-font-size-sm);
  box-shadow: 0 3px 5px 0 var(--gray-300);
  transition: box-shadow var(--transition-timing) var(--transition-duration);
}

@media (hover: hover) {
  :host(:hover) {
    box-shadow: 0 3px 5px 0 var(--gray-400);
  }
}

:host(.active) {
  --background: var(--gray-300);
}

article {
  border-radius: var(--border-radius-unit);
  background-color: var(--background);
  transition: background-color var(--transition-timing)
    var(--transition-duration);
}

@media (min-width: 992px) {

article {
    --padding-unit: 0;

    border: 1px solid var(--border-dark);
    display: grid;
    grid-template-columns: 220px 1fr;
    grid-template-rows: 1fr auto;
    grid-gap: 16px;
    gap: 16px;
    padding: 16px
}

    article header {
      grid-area: 1 / 1 / 3 / 2;
      height: 220px;
    }

    article main {
      grid-area: 1 / 2 / 2 / 3;
    }

    article footer {
      grid-area: 2 / 2 / 3 / 3;
    }
  }

.notice {
  display: flex;
  margin-bottom: -16px;
  padding: 8px var(--padding-unit) 24px;
  border-radius: var(--border-radius-unit) var(--border-radius-unit) 0 0;
  z-index: 1;
}

.notice a {
    color: inherit;
    text-decoration: underline;
  }

.notice bu-icon {
    margin-right: 8px;
  }

.notice span {
    align-self: center;
  }

.notice.t1 {
    background-color: #d70015;
    color: var(--contrast-light);
    font-size: var(--bu-font-size-xs);
    margin-bottom: -16px;
    padding: 16px 16px 32px;
  }

.notice.t1 bu-icon {
      font-size: 20px;
    }

.notice.t2 {
    background-color: #fde7d0;
    color: var(--gray-new-800);
    font-size: var(--bu-font-size-xs);
  }

.notice.t2 bu-icon {
      color: var(--gray-new-500);
    }

.notice.t3 {
    justify-content: center;
    background-color: var(--gray-new-200);
    color: var(--gray-new-700);
    font-weight: 700;
  }

.notice.t4 {
    align-items: center;
    background-color: var(--gray-100);
    font-size: var(--font-size-sm);
  }

.notice.t4 ef-timeago::before {
      content: '•';
      margin-right: 4px;
      margin-left: 2px;
    }

.notice + .notice {
    margin-top: -16px;
  }

header {
  position: relative;
  border-radius: var(--border-radius-unit) var(--border-radius-unit) 0 0;
  overflow: hidden;
  -webkit-mask-image: -webkit-radial-gradient(circle, white, black);
          mask-image: -webkit-radial-gradient(circle, white, black);
}

header slot::slotted(ef-collage) {
    -webkit-mask-image: -webkit-radial-gradient(circle, white, black);
            mask-image: -webkit-radial-gradient(circle, white, black);
    font-size: 10px;
  }

header .notice {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 8px;
    padding-bottom: 8px;
  }

header ef-img-placeholder {
    width: 100%;
    height: 170px;
    background-color: var(--gray-200);
    border-radius: 0;
    font-size: 40px;
  }

@media (min-width: 992px) {

header {
    border-radius: var(--border-radius-unit)
}

    header ef-img-placeholder,
    header slot::slotted(ef-collage) {
      width: 100%;
      height: 100%;
    }
  }

@media (min-width: 992px) {

.wrapper {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto
}
  }

main {
  position: relative;
}

main a {
    --link-text: var(--dark-text);
    --link-text-hover: var(--dark-text);
    --link-text-active: var(--dark-text);

    display: flex;
    flex-direction: column;
    min-height: 200px;
    padding: var(--padding-unit) 90px var(--padding-unit) var(--padding-unit);
  }

main a slot {
      pointer-events: none;
    }

@media (min-width: 992px) {

main a {
      height: 100%;
      min-height: auto;
      padding-top: 0
  }
    }

main .info {
    color: #6d85e1;
    font-weight: 700;
    text-transform: uppercase;
  }

main slot::slotted(.bu-title-3) {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-top: 8px !important;
    margin-bottom: 8px !important;
    overflow: hidden;
    transition: color var(--transition-timing) var(--transition-duration);
  }

main slot::slotted([slot='origin']),
  main .address {
    --icon-color-primary: var(--text-secondary);
    --icon-font-size-primary: var(--bu-font-size-sm);

    color: var(--text-secondary);
  }

main slot::slotted([slot='origin']) {
    margin-bottom: 8px;
  }

main .participants {
    display: flex;
    align-items: center;
    margin-top: auto;
  }

main .participants span {
      margin-left: 8px;
    }

main .address {
    margin-top: 8px;
  }

main .quick-actions {
    position: absolute;
    top: var(--padding-unit);
    right: var(--padding-unit);
    display: flex;
  }

@media (min-width: 992px) {

main .quick-actions {
      top: 0;
      right: 0
  }
    }

main ef-social-share {
    margin-right: 4px;
  }

main ef-social-share span {
      display: none;
    }

footer {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px var(--padding-unit);
  border-top: 1px solid var(--border-light);
}

@media (min-width: 992px) {

footer {
    bottom: -8px;
    margin-top: -8px;
    padding-bottom: 0
}
  }

footer ::slotted(*:not(:last-child)) {
    margin-right: 16px !important;
  }

footer ::slotted(bu-card-attend-menu) {
    min-width: 1px;
    margin-left: auto;
  }

footer ::slotted([class*='btn-naked']) {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

ef-avatar-list.avatar-list-sm {
  --avatar-size: 24px;
  --avatar-border: 1px solid var(--contrast-light);
  --avatars-overlap: 8px;
  --label-padding: 0 0 0 8px;
  --label-bg: transparent;
  --label-text: inherit;
  --label-font-size: var(--bu-font-size-xs);
  --label-font-weight: 400;
}
`;
export default styles;
